module.exports = __webpack_public_path__ + "img/fenqu.44b1bed3.png";